import { AdminItemTitleType } from 'types/admin/courses';
import { Input } from '@trackman/web-shared-components';
import { LanguageType } from 'types/languages';
import Paragraph from 'components/TextComps/Paragraph';
import { getLanguageText } from 'utilities/languages';
import { observer } from 'mobx-react-lite';

type Props = {
  titles: AdminItemTitleType[];
  languages: LanguageType[];
};

export const TitleInputs = observer(({ titles, languages }: Props) => {
  return (
    <div className='admin-edit-section'>
      <h2>Title*</h2>
      <div className='inputs-container'>
        {languages.map((language) => {
          const foundTitle = titles.find((title) => title.countryCode === language);

          return (
            <div key={language} className='input-wrapper'>
              <Paragraph>
                <>{getLanguageText(foundTitle?.countryCode ?? language)}</>
              </Paragraph>
              <Input
                label={`${getLanguageText(language)} title`}
                value={foundTitle?.text ?? ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  foundTitle
                    ? (foundTitle.text = e.currentTarget.value)
                    : titles.push({ countryCode: language, text: e.currentTarget.value })
                }
              />
            </div>
          );
        })}
      </div>
    </div>
  );
});

export default TitleInputs;
